import React, { memo, useState, useEffect } from "react";
import { getCardsData } from "@/api/home";

import styles from "./style.module.less";
import ImgComps from "../../../ImgComps";
import { Iprops } from "../..";
export interface cardItem {
  pcCoverUrl: string | null;
  title: string | null;
  content: string | null;
  pcUrl: string | null;
  applicationBaseInfoList: {
    homeUrl: string;
    deploymentType: number;
    deepLink: string | null;
    eGovHomeUrl: string | null;
    hostAppClient: number;
  }[];
  applicationKey: string | null;
  linkType?: 1 | 2 | 3;
  urlType?: 1 | 2 | 3;
  mobileUrl: string | null;
  applicationId?: string | null;
  applicationName?: string | null;
  imgUrl: string | null;
}
export interface cardInterface {
  operationTiles: cardItem[];
}
const Cards = memo(({ onAppOrLinkClick, t }: Iprops) => {
  const [cardsData, setCardsData] = useState<cardItem[]>([]);

  useEffect(() => {
    getCardsData().then((res: cardInterface) => {
      console.log(res, "res111");
      const count = res?.operationTiles.length;
      const remove = count % 2;
      remove && res?.operationTiles.splice(count - remove, remove);
      setCardsData(res.operationTiles);
    });
  }, []);

  return (
    <div className={styles.wrapper}>
      {cardsData?.map((item: any, index: any) => (
        <div
          className={styles.wrapper_item2_common}
          key={index}
          onClick={() => {
            onAppOrLinkClick(item);
          }}
        >
          {item.pcCoverUrl && <ImgComps className={styles.bg_image} src={item.pcCoverUrl} />}
          <div className={`${styles.cnt_col7_common}`}>
            <span className={styles.txt9_common}>{item.title}</span>
            <span className={styles.txt10_common}>{item.content}</span>
          </div>
        </div>
      ))}
    </div>
  );
});

export default Cards;
